export default {
  COOKIE_KEY_CURRENT_USER_ID:'member/current_user_id',
  list:[],
  listAll:[],
  listInfo:{},

  memberInfo:{}

}
